import { render, staticRenderFns } from "./ImmuneTestList.vue?vue&type=template&id=07002db9&"
import script from "./ImmuneTestList.vue?vue&type=script&lang=js&"
export * from "./ImmuneTestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports